import React from 'react';
import { IoIosMore } from 'react-icons/io';
import UserAvatar from '../../components/UserAvatar';
import FilePreview from './FilePreview';
import { formatTimeAgo } from '../../utils/Date';

const MessageList = ({
  selectedTicket,
  showMoreMenu,
  toggleMoreMenu,
  moreMenuRef,
  handleStatusChange,
  handleDeleteTicket,
  setShowMoreMenu,
}) => {
  if (!selectedTicket) {
    return (
      <div className="flex-1 p-4 bg-[#F4F5F7] overflow-y-auto">
        <p className="text-[11px] font-light text-gray-500">Click on a ticket to view details</p>
      </div>
    );
  }

  return (
    <div className="flex-1 p-4 bg-[#F4F5F6] overflow-y-auto">
      {/* Ticket Header Section */}
      <div className="flex">
        <div className="flex-shrink-0 mr-4">
          <UserAvatar
            user={selectedTicket?.userId}
            variant="square"
            useInitials={true}
            bgColor="black"
          />
        </div>
        <div className="flex flex-col flex-1 max-w-md p-4 mb-4 text-white bg-black rounded-lg">
          <div className="flex items-center">
            <div className="text-sm">{selectedTicket?.message}</div>
          </div>
          <div className="text-sm text-gray-300 mt-2 text-right">
            {formatTimeAgo(selectedTicket?.createdAt)}
          </div>
        </div>
      </div>

      {/* Replies Section */}
      <div className="space-y-4">
        {selectedTicket.replies
          ?.slice()
          .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
          .map(reply => {
            const isAdminReply = reply.adminId;
            return (
              <div
                key={reply._id}
                className={`flex ${isAdminReply ? 'justify-end' : 'justify-start'}`}>
                <div className="flex">
                  {!isAdminReply && (
                    <div className="flex-shrink-0 mr-4">
                      <UserAvatar
                        user={reply.userId || selectedTicket?.userId}
                        variant="square"
                        useInitials={true}
                        bgColor="black"
                      />
                    </div>
                  )}
                  <div className="flex flex-col">
                    <div className="flex items-center">
                      <div
                        className={`${
                          isAdminReply ? 'bg-gray-200 text-black' : 'bg-black text-white'
                        } rounded-lg p-4 max-w-md flex-1`}>
                        <div className="text-sm font-light">{reply.message}</div>

                        {/* File preview for admin replies */}
                        {isAdminReply && reply.file && (
                          <FilePreview fileUrl={reply.file} fileName={reply.fileName} />
                        )}
                      </div>
                      {isAdminReply && (
                        <div className="relative flex items-center ml-2">
                          <button onClick={() => toggleMoreMenu(reply._id)}>
                            <IoIosMore className="w-4 h-4 text-black cursor-pointer" />
                          </button>
                          {showMoreMenu === reply._id && (
                            <div
                              ref={moreMenuRef}
                              className="absolute right-0 z-10 py-1 bg-white border border-gray-200 rounded shadow-lg top-6 min-w-32">
                              <button
                                className="w-full text-left px-4 py-2 text-sm font-light hover:bg-gray-100"
                                onClick={() => {
                                  handleStatusChange(selectedTicket._id, 'closed');
                                  toggleMoreMenu(null);
                                }}>
                                Close Ticket
                              </button>
                              <button
                                className="w-full text-left px-4 py-2 text-sm font-light text-red-600 hover:bg-gray-100"
                                onClick={() => {
                                  handleDeleteTicket(selectedTicket._id);
                                  setShowMoreMenu(null);
                                }}>
                                Delete Ticket
                              </button>
                            </div>
                          )}
                        </div>
                      )}
                    </div>

                    {/* File preview*/}
                    {!isAdminReply && reply.file && (
                      <div className="flex items-center mt-2">
                        <img src={reply.file} alt="file" className="max-w-xs rounded-lg" />
                      </div>
                    )}

                    <div
                      className={`text-sm font-light text-gray-500 mt-1 ${
                        isAdminReply ? 'text-right mr-6' : ''
                      }`}>
                      {formatTimeAgo(reply.createdAt)}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default MessageList;
